module.exports = __webpack_public_path__ + "assets/img/news-card-pa.ce94aaea.png";